import { useSearchBenchmarksQuery, useSearchCollectionsQuery } from '@vizit/api';

/**
 * Totals shown on the Collections / Benchmarks switch: every collection and
 * every benchmark in the workspace, regardless of the active filters.
 *
 * The collection total is read from a one-item page, so it costs a single
 * small request. The benchmark list is unpaged, so its query is shared with
 * the unfiltered Benchmarks view and usually comes from cache.
 */
function useCollectionsViewCounts({ workspaceId, isEnabled }: { workspaceId?: string; isEnabled: boolean }) {
  const enabled = isEnabled && !!workspaceId;

  const { data: collectionCount } = useSearchCollectionsQuery(
    { workspace_id: workspaceId ?? '', limit: 1, offset: 0 },
    { enabled, select: (result) => result.total_count },
  );

  const { data: benchmarkCount } = useSearchBenchmarksQuery(
    { workspace_id: workspaceId ?? '', sort_by: 'created_at', sort_direction: 'desc' },
    { enabled, select: (benchmarks) => benchmarks.length },
  );

  return { collectionCount, benchmarkCount };
}

export { useCollectionsViewCounts };
